import DownloadForm from './download-form';
import FormValidation from '../form-validation';
import { messageBoxSuccess, messageBoxError } from '../message-box';
class DownloadFormPopupPassword extends DownloadForm {

  private isSending: Boolean = false;

  protected nameSelector = '#popup-password form';
  protected nameInputSelector = 'input[type="password"]';


  protected formOpenTrigger: HTMLElement | null | undefined = null;
  protected formOpenTarget: HTMLElement | null | undefined = null;

  protected requestForm: HTMLFormElement;

  private requestFormValidation: FormValidation;

  init() {
    super.init();

    this.formOpenTrigger = document.querySelector('#popup-password .js-popup-download__open-trigger') as HTMLElement;
    this.formOpenTarget = document.querySelector('#popup-password .js-popup-download__open-target') as HTMLElement;
    this.requestForm = document.querySelector('#popup-password .js-popup-download__request') as HTMLFormElement;

    if (this.formOpenTrigger) {
      this.formOpenTrigger.addEventListener('click', () => {
        this.formOpenTarget?.classList.remove('hidden');
      })
    }

    this.requestFormValidation = new FormValidation(
      this.requestForm,
      this.onRequestFormSubmit.bind(this)
    );
    this.requestFormValidation.init();
  }

  async onRequestFormSubmit(formEl: HTMLFormElement) {
    if (this.isSending) return;

    formEl.classList.add('loading');
    this.toggleFormError();

    var formData = new FormData(formEl);

    await fetch(formEl.action, {
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(data => this.handleSubmitResponse(data, formEl))
      .catch(error => this.handleSubmitResponse(error, formEl));
  }

  private handleSubmitResponse(data: any, formEl: HTMLFormElement) {
    if (!data.success || data.success == 'false') {
      formEl.classList.remove('loading');
      messageBoxError({
        contentDe: 'Es ist ein Fehler aufgetreten',
        contentEn: 'an error appeared',
      });
    } else {
      formEl.classList.remove('loading');
      formEl.reset()
      const passwordPopup = document.querySelector('#popup-password');
      passwordPopup?.classList.add('success');
      passwordPopup?.querySelector('.m-popup__intro')?.classList.add('hidden');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ lead: null });
      window.dataLayer.push({
        event: 'generate_lead',
        lead: {
          type: 'form_download',
          email: data.validated_data.email,
          content_type: 'file',
          file_title: data.hasOwnProperty('file_title') ? data.file_title : 'unknown',
          new_lead: data.hasOwnProperty('is_first_contact') && data.is_first_contact ? 'Yes' : 'No'
        }
      });
    }
    this.isSending = false;
  }

  toggleFormError(setError: boolean = false) {
    const { requestForm } = this;
    const errorMessageContainer = requestForm.querySelector('.error-message') as HTMLElement;
    if(requestForm.dataset.error) {
      const errorMessage = requestForm.dataset.error || errorMessageContainer.dataset.errorDefault;
      if(setError) {
        requestForm.classList.add('has-error');
        if(errorMessage) errorMessageContainer.innerText = errorMessage;
        errorMessageContainer.classList.remove('hidden');
      } else {
        requestForm.classList.remove('has-error');
        errorMessageContainer.classList.add('hidden');
      }
    }
  }
}

export default DownloadFormPopupPassword;
